import { blue, deepOrange, green, grey } from '@mui/material/colors';

const chartingMenuSx = (theme) => ({
    menuContainer: {
        padding: theme.spacing(0.5),
        textAlign: 'center',
        overflowY: 'hidden',
        overflowX: 'auto',
    },
    buttonMarginRight: {
        marginRight: theme.spacing(2),
    },
    buttonFloat: {
        //float: 'left',
    },
    buttonSmall: {
        minWidth: '32px',
        paddingLeft: '8px',
        paddingRight: '8px',
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    activeItem: {
        background: theme.palette.primary[50],
    },
    lineExtraThin: {
        width: 'calc(100% - 16px)',
        height: '1px',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    lineThin: {
        width: 'calc(100% - 16px)',
        height: '4px',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    lineMedium: {
        width: 'calc(100% - 16px)',
        height: '8px',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    lineThick: {
        width: 'calc(100% - 16px)',
        height: '12px',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    dxColor: {
        color: blue[900],
    },
    txColor: {
        color: deepOrange[900],
    },
    otherColor: {
        color: green[900],
    },
    symbolButtonGroup: {
        width: '100%',
        padding: '4px',
    },
    symbolOtherButton: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[600],
        },
    },
    autoSaveOff: {
        color: grey[500],
    },
    autoSaveOn: {
        color: green[500],
    },
    saveButtonGroup: {
        marginLeft: theme.spacing(2),
        verticalAlign: 'middle',
    },
    saveProgress: {
        display: 'block',
    },
    saveLeadingSlot: {
        width: 24,
        height: 24,
        marginRight: theme.spacing(1),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

export default chartingMenuSx;
